export const DATE_FORMAT: string = 'dd/MM/yyyy HH:mm';
export const RESEND_OTP_IN_SEC: number = 20;
export const OTP_LENGTH: number = 4;
/**
 * Portal paths that only exist for salon locations. A restaurant location has
 * no services to sell, so these are hidden from the navigation and blocked in
 * the router — see `location-business-type`.
 */
export const SERVICE_PATHS = ['/dashboard/services'];
